import React, { useCallback, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Modal, StackLayout, useModalStore, Button } from '@wemogy/reactbase';
import useAuthorizationStore from '../../../hooks/UseAuthorizationStore';
import RoleEditor from '../../role/roleEditor/RoleEditor';
var DebugRoleModal = function () {
    var authorizationStore = useAuthorizationStore();
    var debugRole = authorizationStore.debugRole;
    var manageRoleModal = authorizationStore.config.ui.manageRoleModal;
    var activePermissionCache = authorizationStore.activePermissionCache;
    var modalStore = useModalStore();
    useEffect(function () {
        if (!activePermissionCache) {
            return;
        }
        console.log('activePermissionCache changed');
    }, [activePermissionCache]);
    var handleSave = useCallback(function () {
        if (!activePermissionCache) {
            return;
        }
        debugRole.commitChanges();
        modalStore.closeModal();
    }, [debugRole, activePermissionCache]);
    var handleClose = useCallback(function () {
        debugRole === null || debugRole === void 0 ? void 0 : debugRole.discardChanges();
    }, [debugRole]);
    var handleToggleDebugMode = useCallback(function () {
        if (!activePermissionCache) {
            return;
        }
        if (activePermissionCache.debugRole) {
            activePermissionCache.removeDebugRole();
        }
        else {
            activePermissionCache.setDebugRole(debugRole);
        }
    }, [activePermissionCache, debugRole]);
    if (!activePermissionCache) {
        return null;
    }
    return (React.createElement(Modal, { modalKey: "debugRoleModal", title: 'Debug Role', variationKey: manageRoleModal.modalVariation, onSave: handleSave, onClosePressed: handleClose, widthFitContent: true, onOpened: function () {
            var dimmer = document.querySelector('.ui.dimmer');
            if (dimmer) {
                dimmer.style.background = 'none';
            }
        } },
        React.createElement(StackLayout, null,
            React.createElement(RoleEditor, { role: debugRole }),
            React.createElement(Button, { onPress: handleToggleDebugMode }, activePermissionCache.debugRole ? 'Debugging deaktivieren' : 'Debugging aktivieren'))));
};
export default observer(DebugRoleModal);
//# sourceMappingURL=DebugRoleModal.js.map